import React from "react";
import ReactDOM from "react-dom";
import Swal from "sweetalert2";
import AppButton from "../../button/app-button";
import "./success-alert.css";

const SuccessAlert = ({
	title = "Sucesso",
	description = "",
	actions = []
}) => {
	return (
		<div className="submit-application-success-alert">
			<div className="submit-application-success-alert__icon">
				<span />
			</div>

			<h2>{title}</h2>

			{description && (
				<p>{description}</p>
			)}

			{actions.length > 0 && (
				<div className="submit-application-success-alert__actions">
					{actions.map((action, index) => (
						<AppButton
							key={action.label || index}
							type="button"
							startIcon={action.startIcon}
							endIcon={action.endIcon}
							className={[
								"submit-application-success-alert__button",
								action.variant === "secondary"
									? "submit-application-success-alert__button--secondary"
									: ""
							].filter(Boolean).join(" ")}
							fullWidth
							onClick={action.onClick}
						>
							{action.label}
						</AppButton>
					))}
				</div>
			)}
		</div>
	);
};

export const showSubmitApplicationSuccessAlert = ({
	title,
	description,
	actions = []
}) => {
	return Swal.fire({
		showConfirmButton: false,
		showCloseButton: false,
		allowOutsideClick: false,
		customClass: {
			popup: "submit-application-success-alert__popup"
		},
		html: `<div id="submitApplicationSuccessAlertRoot"></div>`,
		onOpen: () => {
			const root = document.getElementById("submitApplicationSuccessAlertRoot");

			if (!root) {
				return;
			}

			ReactDOM.render(
				<SuccessAlert
					title={title}
					description={description}
					actions={actions}
				/>,
				root
			);
		},
		onClose: () => {
			const root = document.getElementById("submitApplicationSuccessAlertRoot");

			if (root) {
				ReactDOM.unmountComponentAtNode(root);
			}
		}
	});
};

export default SuccessAlert;